import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { QuoteDeclineIds } from "@assets/constants";
import { QuoteDecline } from "@assets/types";
import QuoteService from "@services/QuoteService";
import type { RootState } from "@state/store";

export const getQuoteDeclineReasons = createAsyncThunk("quotes/reasons", () =>
  QuoteService.getQuoteDeclineReasons()
);
export interface QuoteDeclineState {
  reasons: QuoteDecline[];
}

export const initialReasonsState: QuoteDeclineState = {
  reasons: [],
};

export const quoteReasonsSlice = createSlice({
  name: "declineReasons",
  initialState: initialReasonsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getQuoteDeclineReasons.rejected, (state) => {
        state.reasons = [
          { DeclineId: QuoteDeclineIds.DECLINE_OTHER, DeclineMessage: "Other" },
        ];
      })
      .addCase(
        getQuoteDeclineReasons.fulfilled,
        (state, action: PayloadAction<QuoteDecline[]>) => {
          state.reasons = action.payload;
        }
      );
  },
});

export const quoteReasonsState = (state: RootState) => state.quoteReasonsSlice;

export default quoteReasonsSlice.reducer;
